export const HANDLE_SUBMIT = "HANDLE_SUBMIT";
export const HANDLE_REMOVE = "HANDLE_REMOVE";
export const HANDLE_EDIT = "HANDLE_EDIT";
export const SET_SEARCH_QUERY = "SET_SEARCH_QUERY";
export const SET_TOGGLE_SIDEBAR = "SET_TOGGLE_SIDEBAR";
export const ADD_LABEL = "ADD_LABEL";
export const REMOVE_LABEL = "REMOVE_LABEL";
export const EDIT_LABEL = "EDIT_LABEL";
export const HANDLE_ARCHIVE = "HANDLE_ARCHIVE";
export const RESET_ARCHIVE_NOTE = "RESET_ARCHIVE_NOTE";
export const HANDLE_BIN = "HANDLE_BIN";
export const MOVE_TO_ARCHIVE_FROM_BIN = "MOVE_TO_ARCHIVE_FROM_BIN";
export const DELETE_FOREVER = "DELETE_FOREVER";
